import moment from 'moment'
import parameters from './parameters'
import Vue from 'vue'

let filters = new Vue({
  data () {
    return {
      parameters: Object.assign({}, parameters),
      today: moment().format('YYYY-MM-DD')
    }
  },

  watch: {
    today: {
      handler () {
        this.setPeriods()
      },

      immediate: true
    }
  },

  created () {
    setInterval(this.setToday(), 1000 * 60)
  },

  methods: {
    getActorValue (actorId, key) {
      return this.parameters.actors.find(actor => actor.id === actorId)[key]
    },

    getFrequencyValue (frequencyId, key) {
      return this.parameters.frequencies.find(frequency => frequency.id === frequencyId)[key]
    },

    getFreeSalesValue (freeSalesId, key) {
      return this.parameters.freeSales.find(freeSales => freeSales.id === freeSalesId)[key]
    },

    getInvoiceStateValue (stateId, key) {
      return this.parameters.invoiceStates.find(invoiceStates => invoiceStates.id === stateId)[key]
    },

    getPagesStateValue (pageId, key) {
      return this.parameters.pages.find(page => page.id === pageId)[key]
    },

    getPaymentStateValue (stateId, key) {
      return this.parameters.paymentsStates.find(paymentStates => paymentStates.id === stateId)[key]
    },

    getPersonValue (personId, key) {
      return this.parameters.persons.find(person => person.id === personId)[key]
    },

    getSaleStateValue (stateId, key) {
      return this.parameters.salesStates.find(saleState => saleState.id === stateId)[key]
    },

    getSubscriptionStateValue (stateId, key) {
      return this.parameters.subscriptionStates.find(SubscriptionState => SubscriptionState.id === stateId)[key]
    },

    setPeriods () {
      this.parameters.periods[1].dateFrom = moment().format('YYYY-MM-DD')
      this.parameters.periods[1].dateTo = moment().format('YYYY-MM-DD')
      this.parameters.periods[2].dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD')
      this.parameters.periods[2].dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD')
      this.parameters.periods[3].dateFrom = moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.parameters.periods[3].dateTo = moment().format('YYYY-MM-DD')
      this.parameters.periods[4].dateFrom = moment().subtract(14, 'days').format('YYYY-MM-DD')
      this.parameters.periods[4].dateTo = moment().format('YYYY-MM-DD')
      this.parameters.periods[5].dateFrom = moment().subtract(30, 'days').format('YYYY-MM-DD')
      this.parameters.periods[5].dateTo = moment().format('YYYY-MM-DD')
      this.parameters.periods[6].dateFrom = moment().startOf('month').format('YYYY-MM-DD')
      this.parameters.periods[6].dateTo = moment().endOf('month').format('YYYY-MM-DD')
      this.parameters.periods[7].dateFrom = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
      this.parameters.periods[7].dateTo = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
      this.parameters.periods[8].dateFrom = moment().startOf('year').format('YYYY-MM-DD')
      this.parameters.periods[8].dateTo = moment().endOf('year').format('YYYY-MM-DD')
    },

    setToday () {
      this.today = moment().format('YYYY-MM-DD')
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$filters = filters
  }
}
